export class SplitText {
  constructor() {
    document.addEventListener('DOMContentLoaded', function () {
      if (document.getElementsByClassName('js-split-text').length == 0) return
      const initialize = function (el) {
        if (el.children.length > 0) return
        let html = ''
        const textArray = el.textContent.split('')
        const textLength = textArray.length
        const randomArray = new Array(textLength)
        randomArray[Math.floor(Math.random() * textLength)] = true
        for (var i = 0; i < textLength; i++) {
          if (textArray[i] == ' ') {
            html += isIE ? '<span class="split-text">&nbsp;</span>' : '<span class="split-text">&thinsp;</span>'
          } else {
            html += '<span class="split-text">' + textArray[i] + '</span>'
          }
        }
        el.innerHTML = html
      }
      const text = document.querySelectorAll('.js-split-text')
      const node = Array.prototype.slice.call(text, 0)
      const length = node.length
      for (var i = 0; i < length; i++) {
        initialize(node[i])
      }
    })
  }
}
